import avatar from "@assets/avatars/avatar-3.png";
import AvatarWithText from "@core-components/avatar-text/AvatarWithText";
import SSBackgroundImage from "@core-components/backgroundImage/BackgroundImage";
import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import SSHeadLineHeader from "@core-components/title/components/SSHeadLineHeader";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";

export const SmurfsNormalHero = () => {
  const { t } = useAppTranslation("pages.normal");
  const { currentRegion } = useAppRegion();

  return (
    <SSBackgroundImage>
      <SSBgImageHeadline
        subTitle={
          <AvatarWithText avatar={avatar} text={t("banner.subTitle")} />
        }
        header={
          <SSHeadLineHeader>
            {t("banner.header", { region: currentRegion.toUpperCase() })}
          </SSHeadLineHeader>
        }
      >
        <SSWhiteText>{t("banner.titlePrefix")}</SSWhiteText>
        <br />
        <SSLoLGradientText>{t("banner.titleSuffix")}</SSLoLGradientText>
      </SSBgImageHeadline>
    </SSBackgroundImage>
  );
};
